import { call, put } from 'redux-saga/effects'
import { RequestMethods } from 'utils/axios/methods'
import type { PayloadAction } from '@reduxjs/toolkit'
import { Actions_Notifications } from 'redux/modules/notification/Actions'
import { sagaAction_Error } from 'redux/sagas/actions/SagaAction_Error'
import { TStoreTemplate } from 'redux/config/root-types'
import { Actions_ParentOrganizations } from 'redux/modules/parentOrganizations/Actions'
import { TParentOrganization } from 'redux/modules/parentOrganizations/TReducer'

const client = RequestMethods()

export interface ISagaWorker_DeactivateParentOrganization {
  id: number
}

export default function* SagaWorker_DeactivateParentOrganization(
  action: PayloadAction<ISagaWorker_DeactivateParentOrganization>,
) {
  const { id } = action.payload

  try {
    yield put(Actions_ParentOrganizations.store.showLoader())

    const organization: TStoreTemplate<TParentOrganization> = yield call(
      async () => await client.put<TParentOrganization>(`/organizations/parents/${id}/deactivate`),
    )
    yield put(Actions_ParentOrganizations.store.editParentOrganization(organization))

    yield put(
      Actions_Notifications.store.setNotification({
        message: 'Parent organization successfully deactivated',
        type: 'Success',
      }),
    )
  } catch (e) {
    yield call(() => sagaAction_Error(e))
  } finally {
    yield put(Actions_ParentOrganizations.store.hideLoader())
  }
}
